import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxBoxModule, DxButtonModule, DxFileUploaderComponent, DxFileUploaderModule, DxFormModule, DxPopupModule, DxProgressBarModule, DxResponsiveBoxModule, DxScrollViewModule } from 'devextreme-angular';
import { NgForm, ReactiveFormsModule } from '@angular/forms';
import { DxButtonTypes } from 'devextreme-angular/ui/button';
import notify from 'devextreme/ui/notify';
import { AbsaCardImport } from '../../../components/utils/models/absacardimport';
import { KeycloakService } from 'keycloak-angular';
import { EnvironmentService } from '../../../services/environment.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { OutletContext } from '@angular/router';
import { getSizeQualifier, ScreenService } from '../../../services';
import { UtilityFunctions } from '../../../shared/helpers/utility-functions';
import { catchError, Observable, of } from 'rxjs';

@Component({
  standalone: true,
  imports: [ReactiveFormsModule, DxButtonModule, DxFormModule, CommonModule, DxBoxModule, DxResponsiveBoxModule, DxFileUploaderModule,DxScrollViewModule, DxPopupModule, DxProgressBarModule],
  selector: 'app-load-new-cards',
  templateUrl: './load-new-cards.component.html',
  styleUrl: './load-new-cards.component.scss'
})
export class LoadNewCardsComponent implements AfterViewInit {
  @Input() colCount: number = 2;
  getSizeQualifier = getSizeQualifier;

  CardsImported: number = 0;
  @ViewChild('CardsForm') form!: NgForm;
  textFileSource: string | null = null;
  importedfile: File | null = null;
  cardsList : Array<AbsaCardImport> = [];
  UserKeycloakGuidId! : string;
  FileUploadUrl! : string;
  dummyFileUploadUrl! : string;
  popupVisible : boolean = false;
  errorsList : Array<string> = [];
  @Output() OnCardStockUpdate = new EventEmitter<number>();

  @ViewChild("stockCards_fileUploader", { static: false })  stockCardsfileUploader!: DxFileUploaderComponent;
  @ViewChild("stockcards_dropzone_external", { static: false }) stockCardsDropZoneElement!: ElementRef;

  isstockCardsDropZoneActive = false;
  stockCardsimageSource = '';
  stockCardstextVisible = true;
  stockCardsprogressVisible = false;
  stockCardsprogressValue = 0;
  uploadFailed = false;
  NumberOfCardsStatedInFile = 0;
  NumberOfCardsPattern = /NUMBER OF CARDS IN ORDER\s*:\s*(\d+)/
  invalidFileTypeUploaded = false;
  

  constructor(private keycloakService : KeycloakService, private environmentService: EnvironmentService, private http: HttpClient,private cdRef: ChangeDetectorRef, public screen: ScreenService)
  {
    this.onDropZoneEnter = this.onDropZoneEnter.bind(this);
    this.onDropZoneLeave = this.onDropZoneLeave.bind(this);
    this.onUploaded = this.onUploaded.bind(this);
    this.onProgress = this.onProgress.bind(this);
    this.onUploadStarted = this.onUploadStarted.bind(this);
    this.onUploadError = this.onUploadError.bind(this);
    this.onUploadAborted = this.onUploadAborted.bind(this);
    
    this.keycloakService
    .loadUserProfile()
    .then(e => {
      this.UserKeycloakGuidId = e.id!;
    });    
      
    this.FileUploadUrl = this.environmentService.getConfig('BackendApi') + 'api/Cards/import';
    // PLEASE DON"T REMOVE
    this.dummyFileUploadUrl = this.environmentService.getConfig('BackendApi') + 'api/QuickActions/ImportCards'; 
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
    this.setFileUploaderOptions(); 
  }

  screenSize = getSizeQualifier;

  statusFormat(value) {
    return (value * 100).toFixed(2) + " %" ;
  }

  onUploadError(event: any)
  {
      
  }

  onUploadAborted(event: any)
  {
  }

  showOrHideInvalidFileExtensionError(event: any)
  {
    if (event)
    {
      const invalidFiles = event.value.filter((file: any) => {
        const extension = file.name.split('.').pop();
        return !['txt'].includes(extension);
      });

      if (invalidFiles.length > 0) {
        // Display a custom error message for invalid file extensions
        this.invalidFileTypeUploaded = true
      }

    }
  }

  onUploaded(event: any) {
    this.invalidFileTypeUploaded = false
    this.CardsImported = 0;
    var selectorFinishedUploading =  event.element.id as string;
    switch (selectorFinishedUploading) {
      case "stockCards-fileSelector":
        const stockfile = event.file;
        const cardStockfileReader = new FileReader();
        cardStockfileReader.onload = () => {
          this.isstockCardsDropZoneActive = false;
          this.textFileSource = cardStockfileReader.result as string;

          if (this.textFileSource?.split(',').length > 1) {
            atob(this.textFileSource?.split(',')[1])
            .split('\r\n')
            .forEach(
              row => {
                const extractNumberFromRegexMatch = row.match(this.NumberOfCardsPattern);
                if(extractNumberFromRegexMatch != null)
                {
                  this.NumberOfCardsStatedInFile = extractNumberFromRegexMatch ? parseInt(extractNumberFromRegexMatch[1],10) : 0
                }
                
                const currentRow = row.split(' ');
                const CardNumberPattern = /^\d{4}-\d{4}-\d{4}-\d{4}$/
                if(CardNumberPattern.test(currentRow[0])){
                  
                   this.CardsImported++;
                  
                   this.cardsList.push({
                     CardNumber : currentRow[0].replaceAll('-',''),
                     StockCode : currentRow[4],
                     VisaReference : currentRow[6],
                     CardIssuer : "ABSA",
                     CreatedBy : this.UserKeycloakGuidId
                   });
                }
              }
            )
            this.uploadFailed = false;        
          }
          
          this.stockCardsprogressVisible = false;
          this.stockCardsprogressValue = 0;
          
        };
        cardStockfileReader.readAsDataURL(stockfile);
        this.stockCardstextVisible = false;
        break;

    }
    this.importedfile = event.file;

  }

  onDropZoneEnter(e) {
    
    var activeUploadArea =  e.dropZoneElement.id as string;
    switch (activeUploadArea) {
      case "stockCards-UploadArea":
        // code
        this.isstockCardsDropZoneActive = true;
        break;
    }
  }

  onDropZoneLeave(e)
  {  
    var activeUploadArea =  e.dropZoneElement.id as string;
    switch (activeUploadArea) {
      case "stockCards-UploadArea":
        // code
        this.isstockCardsDropZoneActive = false;
        break;
    }
    
  }

  onProgress(e) {
    var selectorFinishedUploading = e.element.id as string;
    switch (selectorFinishedUploading)
    {
      case "stockCards-fileSelector":
        this.stockCardsprogressValue = e.bytesTotal > 0 ? ((e.bytesTotal - e.bytesLoaded) / e.bytesTotal) * 100: 0;
        break;
    }
  }

  onUploadStarted(e) {
    var selectorFinishedUploading =  e.element.id as string;
    
    switch (selectorFinishedUploading)
    {
      case "stockCards-fileSelector":
        this.stockCardsimageSource = '';
        this.stockCardsprogressVisible = true;
        this.textFileSource = null;
        this.importedfile = null;
        break;
    }
  }

  uploadFileToBackend(event) {
    this.errorsList = []
    if(this.cardsList.length > 0)
    {
      const button = event.component;
      button.option('disabled', true);

      this.http.post(this.FileUploadUrl, { cards: this.cardsList })
      .pipe(catchError((error: HttpErrorResponse, caught: Observable<any>): Observable<any> => {
        UtilityFunctions.showErrorMessage(error);
        return of();
      }))
      .subscribe(response => {
            
          UtilityFunctions.showMessage("Cards Imported Successfully!", "success");
          this.OnCardStockUpdate.emit(this.CardsImported);
          this.CardsImported = 0
          this.stockCardsfileUploader.instance.reset()
          this.stockCardstextVisible = true;
          this.importedfile = null;
          this.cardsList = []
          button.option('disabled', false);
        });

    }
  }

  cancel(event){
    const button = event.component;
    this.CardsImported = 0
    this.stockCardsfileUploader.instance.reset()
    this.cardsList = []
    button.option('disabled', false);
  }

  clearFile(event : Event) {
    // Clear the uploaded file and reset related variables
    
    event.stopPropagation();
    this.textFileSource = null;
    this.importedfile = null;
    this.stockCardstextVisible = true;
    this.isstockCardsDropZoneActive = false;
    this.CardsImported = 0;
    this.cardsList = [];
    this.stockCardsprogressVisible = false;
    this.stockCardsprogressValue = 0;
    this.stockCardsfileUploader.instance.reset(); // Clear the file uploader instance
    
  }

  setFileUploaderOptions()
  {

    var allowedFileExtensionsList = ['.txt'];

    this.stockCardsfileUploader.instance.option({
      dropZone: this.stockCardsDropZoneElement.nativeElement,
      dialogTrigger: this.stockCardsDropZoneElement.nativeElement,
      allowedFileExtensions: allowedFileExtensionsList
    });
  }

}
